module.exports = __webpack_public_path__ + "static/media/blob-guitar-phone.af146800.svg";